module.exports = __webpack_public_path__ + "img/download_icon_white.58b54116.svg";